<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>All Late Payments</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<loading v-if="!pendingLoaded" />
								<p v-if="latePaymentList.length == 0 && pendingLoaded">No data</p>
								<md-table v-if="latePaymentList.length > 0">
									<md-table-row>
										<md-table-head>N.O</md-table-head>
										<md-table-head>Payment ID</md-table-head>
										<md-table-head>Client</md-table-head>
										<md-table-head>Payment Date</md-table-head>
										<md-table-head>Principal</md-table-head>
										<md-table-head>Interest</md-table-head>
										<md-table-head>Total</md-table-head>
										<md-table-head>Status</md-table-head>
										<md-table-head>Action</md-table-head>
									</md-table-row>

									<md-table-row v-for="(payment, index) in latePaymentList">
										<md-table-cell>{{ index + 1 }}</md-table-cell>
										<md-table-cell>{{ payment.hash_id }}</md-table-cell>
										<md-table-cell><b>ID: {{payment.client_hash_id}}</b> ({{ payment.name }})</md-table-cell>
										<md-table-cell>{{ config.datelify(payment.due_date) }}
											({{config.timelify(payment.due_date)}})</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest + payment.principal) }}
										</md-table-cell>
										<md-table-cell>
											<span class="late">{{ config.getStatus(payment.status) }}</span>
										</md-table-cell>
										<md-table-cell>
											<router-link :to="'/loans/detail/' + payment.loan_hash_id">
												<md-button class="md-just-icon md-simple md-success">
													<md-icon>visibility</md-icon>
													<md-tooltip md-direction="top">View loan information</md-tooltip>
												</md-button>
											</router-link>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>

							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>Current Month: Uncoming Payments</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<loading v-if="!pendingLoaded" />
								<p v-if="pendingPaymentList.length == 0 && pendingLoaded">No data</p>
								<md-table v-if="pendingPaymentList.length > 0">
									<md-table-row>
										<md-table-head>N.O</md-table-head>
										<md-table-head>Payment ID</md-table-head>
										<md-table-head>Client</md-table-head>
										<md-table-head>Payment Date</md-table-head>
										<md-table-head>Principal</md-table-head>
										<md-table-head>Interest</md-table-head>
										<md-table-head>Total</md-table-head>
										<md-table-head>Status</md-table-head>
										<md-table-head>Action</md-table-head>
									</md-table-row>

									<md-table-row v-for="(payment, index) in pendingPaymentList" v-if="payment.due_date > ((new Date()).getTime() / 1000)">
										<md-table-cell>{{ index + 2 }}</md-table-cell>
										<md-table-cell>{{ payment.hash_id }}</md-table-cell>
										<md-table-cell><b>ID: {{payment.client_hash_id}}</b> ({{ payment.name }})</md-table-cell>
										<md-table-cell>{{ config.datelify(payment.due_date) }}
											({{config.timelify(payment.due_date)}})</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest + payment.principal) }}
										</md-table-cell>
										<md-table-cell>
											<span class="active">{{ config.getStatus(payment.status) }}</span>
										</md-table-cell>
										<md-table-cell>
											<router-link :to="'/loans/detail/' + payment.loan_hash_id">
												<md-button class="md-just-icon md-simple md-success">
													<md-icon>visibility</md-icon>
													<md-tooltip md-direction="top">View loan information</md-tooltip>
												</md-button>
											</router-link>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>

							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>Current Month: Paid Payments</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100 text-right">
								<md-button class="md-raised md-primary" @click="showPaidAction()">Show/Hide Paid Payments</md-button>
							</div>

							<div class="md-layout-item md-small-size-100 md-size-100" v-if="showPaid">
								<loading v-if="!paidLoaded" />
								<p v-if="paidPaymentList.length == 0 && paidLoaded">No data</p>
								<md-table v-if="paidPaymentList.length > 0">
									<md-table-row>
										<md-table-head>N.O</md-table-head>
										<md-table-head>Payment ID</md-table-head>
										<md-table-head>Client</md-table-head>
										<md-table-head>Paid Date</md-table-head>
										<md-table-head>Principal</md-table-head>
										<md-table-head>Interest</md-table-head>
										<md-table-head>Total</md-table-head>
										<md-table-head>Status</md-table-head>
										<md-table-head>Action</md-table-head>
									</md-table-row>

									<md-table-row v-for="(payment, index) in paidPaymentList">
										<md-table-cell>{{ index + 1 }}</md-table-cell>
										<md-table-cell>{{ payment.hash_id }}</md-table-cell>
										<md-table-cell><b>ID: {{payment.client_hash_id}}</b> ({{ payment.name }})</md-table-cell>
										<md-table-cell>{{ config.datelify(payment.paid_date) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest + payment.principal) }}
										</md-table-cell>
										<md-table-cell>
											<span class="active">{{ config.getStatus(payment.status) }}</span>
										</md-table-cell>
										<md-table-cell>
											<router-link :to="'/loans/detail/' + payment.loan_hash_id">
												<md-button class="md-just-icon md-simple md-success">
													<md-icon>visibility</md-icon>
													<md-tooltip md-direction="top">View loan information</md-tooltip>
												</md-button>
											</router-link>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>Payment by Range</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-field>
									<label>Payment Start Date</label>
									<md-input type="text" v-model="range.start_date" style="display:none" />
									<datetime type="date" v-model="range.start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">

								<md-field>
									<label>Payment End Date</label>
									<md-input type="text" v-model="range.end_date" style="display:none" />
									<datetime type="date" v-model="range.end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" style="width:100%" @click="getData()">SHOW</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table v-if="rangePaymentList.length > 0">
									<md-table-row>
										<md-table-head>N.O</md-table-head>
										<md-table-head>Payment ID</md-table-head>
										<md-table-head>Client</md-table-head>
										<md-table-head>Payment Date</md-table-head>
										<md-table-head>Principal</md-table-head>
										<md-table-head>Interest</md-table-head>
										<md-table-head>Total</md-table-head>
										<md-table-head>Status</md-table-head>
										<md-table-head>Action</md-table-head>
									</md-table-row>

									<md-table-row v-for="(payment, index) in rangePaymentList">
										<md-table-cell>{{ index + 2 }}</md-table-cell>
										<md-table-cell>{{ payment.hash_id }}</md-table-cell>
										<md-table-cell><b>ID: {{payment.client_hash_id}}</b> ({{ payment.name }})</md-table-cell>
										<md-table-cell>{{ config.datelify(payment.due_date) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
										<md-table-cell>{{ config.moneylify(payment.interest + payment.principal) }}
										</md-table-cell>
										<md-table-cell>
											<span class="active">{{ config.getStatus(payment.status) }}</span>
											<br><span v-if="payment.paid_date > 0">({{config.datelify(payment.paid_date)}})</span>
										</md-table-cell>
										<md-table-cell>
											<router-link :to="'/loans/detail/' + payment.loan_hash_id">
												<md-button class="md-just-icon md-simple md-success">
													<md-icon>visibility</md-icon>
													<md-tooltip md-direction="top">View loan information</md-tooltip>
												</md-button>
											</router-link>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			Datetime
		},
		data() {
			return {
				range:{
					start_date: "",
					end_date: ""
				},
				pendingLoaded: false,
				pendingPaymentList: [],
				paidLoaded: false,
				paidPaymentList: [],
				lateLoaded: false,
				latePaymentList: [],
				rangePaymentList: [],
				showPaid: false,
				showPending: false,
				showLate: false
			}
		},
		created() {
			this.getPending();
			this.getPaid();
			this.getLate();
		},
		methods: {
			showPaidAction() {
				this.showPaid = !this.showPaid
			},
			showLateAction() {
				this.showLate = !this.showLate
			},
			showPendingAction() {
				this.showPending = !this.showPending
			},
			getLate(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get_late_payment").then(data => {
					this.latePaymentList = data.body.data
					this.lateLoaded = true
				})
			},
			getPending(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get_monthly_pending_payment").then(data => {
					this.pendingPaymentList = data.body.data
					this.pendingLoaded = true
				})
			},
			getPaid(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get_monthly_paid_payment").then(data => {
					this.paidPaymentList = data.body.data
					this.paidLoaded = true
				})
			},
			getData() {
				let start_date = (new Date(this.range.start_date)).getTime();
				let end_date = (new Date(this.range.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/loan/get_payment_by_range/" + start_date + "/" + end_date).then(data => {
					this.rangePaymentList = data.body.data
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Calendar.vue